export default __webpack_public_path__ + "static/media/WebLandingScreen.e8a76407.gif";